'use strict';

exports.__esModule = true;
exports.fetchUser = undefined;

var _fetch = require('./fetch');

// eslint-disable-next-line import/prefer-default-export
var fetchUser = exports.fetchUser = function fetchUser() {
    var url = (0, _fetch.getMarketUrl)() + '/api/appwise/v2/core/users/me';
    return (0, _fetch.get)(url);
};